module.exports = __webpack_public_path__ + "img/Users-background-blue.8af29f44.svg";